import React from 'react';

const JSON_HTML = () => {
  return (
    <div >
      <h1>JSON_HTML</h1>
      <p>Placeholder component for: "JSON HTML"</p>
    </div>
  );
};

export default JSON_HTML;
